import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
//import {ToastComponent} from "../../shared/toast/toast.component";
import * as moment from 'moment';
//import * as _ from 'lodash';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StudentDashService } from './services/student-dash.service';
import { AuthService } from '../../shared/services/auth.service';
import { TokenStorageService } from '../../shared/services/token-storage.service';
import { User } from '../../models/user.model';
import { ToastNotificationService } from 'src/app/shared/services/toast-notify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-student-dash',
  templateUrl: './student-dashboard.component.html',
  styleUrls: ['./student-dashboard.component.scss']
})
export class StudentDashComponent implements OnInit {

  title = 'student-dash';
  userProfile: User;

  constructor(private router: Router, private _http: HttpClient,
              private studentDashService: StudentDashService,private toastNotifyService: ToastNotificationService,
              private authService: AuthService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    console.log('--inside  StudentDashComponent- ngOnInit----');
    //this.getUserProfile();
    this.saveUserData();
    //this.testMethod();
  }

  saveUserData(){
    console.log('>>>>>saveUserData- student>>>>> ')
    const userData: User = {
      userName: this.tokenStorageService.getUser(),userRole: this.tokenStorageService.getUserRole(),
      clientName: this.tokenStorageService.getTenantName(), branchCode: this.tokenStorageService.getBranchCode(), 
      branchName: this.tokenStorageService.getBranchName(),ownerName: this.tokenStorageService.getOwnerName()}

    this.studentDashService.saveUserData(userData).subscribe({
      next: (response: any) => {
        console.log(">>>saveUserData from service-student: "+JSON.stringify(response)); 
        if(environment.SUCCESS == response.status){
          this.userProfile =  response.data; 
          this.toastNotifyService.showSuccess(response.message, "Notification");
        }else if(environment.FAILURE == response.status){
          this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }                   
      },
      error: (e) => {
        console.error('!!!! error in saveUserData: ',e);          
      }
    });
  }

  testMethod() {    
    console.log('>>>>>testMethod>>>>> ')
    let userName= Cookie.get('user_name')
    this.studentDashService.testMethod(userName).subscribe({
      next: (data: any) => {
        console.log(">>>testdata from service: "+JSON.stringify(data)); 
        this.userProfile =   data            
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }
  /*getUserProfile() {    
    console.log('>>>>>getUserProfile>>>>> ')
    this.adminDashService.getUserProfile().subscribe({
      next: (data: any) => {
        console.log(">>>getUserProfile from service: "+JSON.stringify(data)); 
        this.userProfile =   data            
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }
  getUserData(){
    console.log('>>>>>getUserData- sidebar-admin>>>>> ')
    this.adminDashService.getUserData().subscribe({
      next: (response: any) => {
        console.log(">>>getUserData from service:sidebar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.userProfile =  response.data;
        }else{
          // Get from cookie beacuse it happens for first time
          const userData: User = {
            userName: this.tokenStorageService.getUser(),userRole: this.tokenStorageService.getUserRole(),
            clientName: this.tokenStorageService.getTenantName(), ownerName: this.tokenStorageService.getOwnerName()}
          
          this.userProfile = userData;
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }*/

}